module.exports = __webpack_public_path__ + "img/profile-img.055a9197.png";